const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuadro = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 125.75 75.96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M.38.38v75.2h125V.38Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M118.87,69.08H6.87V6.87h112Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M118.87,51.92l-33.6-24",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M6.87,51.92V69.08h112V51.92",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M51.67,51.92l-22.4-16-22.4,16",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M85.27,34.47l28.27,20.19",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M57.21,27.17a5.34,5.34,0,1,1-5.34-5.34A5.34,5.34,0,0,1,57.21,27.17Z",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M85.27,27.92,43.67,57.63",
    style: {
      fill: "#fff",
      stroke: "#34495e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuadro);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quadro.5b03ec7ef989eca57261115ba8f3d9b0.svg";